module.exports = __webpack_public_path__ + "img/jucai1.e5e6321c.jpg";